<template>
  <div class="row misc-items-tier-form">
    <div class="col-md-12">
      <b-button class="p-0 mb-2" variant="link" @click="onNewMiscellaneousItemClick">
        <font-awesome-icon :icon="'plus'" style="font-size: .9em"></font-awesome-icon>
        {{ $t('Add Miscellaneous Charges') }}
      </b-button>
    </div>
    <div class="col-md-12" v-if="model.miscellaneous_items.length > 0">
      <div class="row">
        <div class="col-md-12">
          <table class="info-table table table-sm miscellaneous-table">
            <tr>
              <th style="width: 35%">{{ $t('Description') }}</th>
              <th style="width: 35%">{{ $t('Comment') }}</th>
              <th style="width: 20%">{{ $t('Amount') }}</th>
              <th style="width: 15%" class="text-center">{{ $t('Inventory Item') }}</th>
              <th style="width: 10%" class="text-center">{{ $t('Taxable') }}</th>
              <th style="width: 10%" class="text-center">{{ $t('Actions') }}</th>
            </tr>

            <tr :key="`miscellaneous-item-${index}`" v-for="(item, index) in model.miscellaneous_items">
              <td class="d-flex pr-3">
                <input-widget v-if="hasPredefinedMiscCharges" style="flex: 1" :items="miscellaneousItemCharges"
                              value-field="value"
                              display-field="${item.key}"
                              @select2Select="onMiscChargeDescriptionDropdownValueChange(item)"
                              type="select2" :model="item" :label="false" attribute="description_dropdown_value"
                              :rules="item.amount ? 'required' : ''"/>
                <input-widget v-if="item.description_dropdown_value === 'other' || !hasPredefinedMiscCharges"
                              style="flex: 1"
                              :class="{'ml-2': hasPredefinedMiscCharges}"
                              :rules="item.amount ? 'required|max:255' : 'max:255'"
                              :model="item" attribute="description" :label="false"/>
              </td>
              <td>
                <input-widget v-if="hasPredefinedMiscCharges"
                              value-field="value"
                              display-field="${item.key}"
                              type="text" :model="item" :label="false" attribute="comment"/>
              </td>
              <td>
                <currency-input-widget :rules="item.description_dropdown_value ? 'required' : ''" :model="item"
                                       attribute="amount"
                                       :label="false"/>
              </td>
              <td>
                <input-widget :model="item" attribute="inventory_uuid" type="select2" :items="model.inventories"
                              value-field="uuid" :label="false" :options="{placeholder: $t('Inventory')}"
                              display-field="${item.item_no}"/>
              </td>
              <td class="text-center">
                <input-widget attribute="taxable" :model="item" type="checkbox" :label="false"
                              style="padding-top: 0.6em"/>
              </td>
              <td class="text-center pt-md-3">
                <b-tooltip :target="`remove-misc-item-button-${index}`" :title="$t('Delete')"/>
                <font-awesome-icon class="text-danger hover-cursor" :id="`remove-misc-item-button-${index}`"
                                   @click="onMiscellaneousItemDelete(index)" style="font-size: 1.5em;" :icon="'times'"/>
              </td>
            </tr>

          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import InputWidget from "@/core/components/input-widget/InputWidget";
  import MiscellaneousItem from "@/modules/receipt/MiscellaneousItem.model";
  import CurrencyInputWidget from "@/core/widgets/CurrencyInputWidget";
  import BaseModel from "@/core/components/input-widget/BaseModel";
  import {createNamespacedHelpers} from "vuex";

  const {mapState: globalMapState} = createNamespacedHelpers('global');

  export default {
    name: "MiscellaneousItemTiersForm",
    components: {CurrencyInputWidget, InputWidget},
    props: {
      model: {
        type: BaseModel,
        required: true
      }
    },
    computed: {
      ...globalMapState({
        miscellaneousItemCharges: state => state.miscellaneousItemCharges
      }),
      hasPredefinedMiscCharges() {
        return this.miscellaneousItemCharges && this.miscellaneousItemCharges.length > 1;
      },
    },
    methods: {
      onNewMiscellaneousItemClick() {
        this.model.miscellaneous_items.push(new MiscellaneousItem({taxable: true}))
      },
      onMiscellaneousItemDelete(index) {
        for (let i = 0; i < this.model.miscellaneous_items.length; i++) {
          if (i === index) {
            this.model.miscellaneous_items.splice(i, 1);
            break;
          }
        }
      },
      onMiscChargeDescriptionDropdownValueChange(item) {
        item.description = '';
      },
    },
  }
</script>

<style lang="scss" scoped>
  .miscellaneous-table {
    /deep/ .form-group {
      margin-top: .2em;
      margin-bottom: .5em;
    }
  }
</style>
